// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.embed-container[data-v-2209ef34]{\n  position:relative;\n  padding-bottom:56.25%;\n  height:0;\n  overflow:hidden;\n  max-width:100%;\n  pointer-events:none\n}\n.embed-container embed[data-v-2209ef34],.embed-container iframe[data-v-2209ef34],.embed-container object[data-v-2209ef34]{\n  position:absolute;\n  top:0;\n  left:0;\n  width:100%;\n  height:100%\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
